import React, { useEffect } from 'react';
import './ImageLightbox.css';

interface ImageLightboxProps {
    image: string;
    alt: string;
    onClose: () => void;
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({ image, alt, onClose }) => {
    useEffect(() => {
        // Prevent body scroll when modal is open
        document.body.style.overflow = 'hidden';

        // Handle escape key press
        const handleEscape = (e: KeyboardEvent) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleEscape);

        return () => {
            document.body.style.overflow = 'unset';
            window.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    return (
        <div className="lightbox-overlay" onClick={onClose}>
            <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                <button className="lightbox-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
                <img src={image} alt={alt} className="lightbox-image" />
            </div>
        </div>
    );
};

export default ImageLightbox;
